<style lang="scss">

</style>

<template>
    <div id='impressum-page'>
        <h2>{{ $t('site.impressum-page.name') }}</h2>
    </div>
</template>

<script>
export default {
    data () {
        return {
        }
    },
}
</script>
